import React from 'react';
import { Helmet } from 'react-helmet-async';

type PropTypes = {
  title: string;
  description: string;
  imageUrl: string;
  name: string;
  type: string;
};

export const SEO = ({
  title,
  description,
  imageUrl,
  name,
  type,
}: PropTypes) => {
  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {/* End standard metadata tags */}
      {/* Facebook tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      {/* End Facebook tags */}
      {/* Twitter tags */}
      <meta name="twitter:creator" content={name} />
      <meta name="twitter:card" content={type} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      {/* End Twitter tags */}
    </Helmet>
  );
};
